import { QR_DIAGNOSTICS, DESC, QR_DIAG_SORT_FIELD, ASC, OPEN } from 'app/constants';

const INIT_STATE = {
  list: [],
  config: {
    total: 0,
    page: 1,
    sort_field: QR_DIAG_SORT_FIELD.REGISTERED_AT,
    sort_order: DESC,
    status: OPEN,
    isTrashOpen: false
  },
  item: null,
  isLoading: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case QR_DIAGNOSTICS.SET_LOADING:
      return { ...state, isLoading: action.payload };
    case QR_DIAGNOSTICS.SET_LIST: {
      const { pagination } = action.payload;
      return {
        ...state,
        list: action.payload.data,
        config: { ...state.config, total: pagination.total },
      };
    }
    case QR_DIAGNOSTICS.SET_PAGE_OFFSET: {
      return {
        ...state,
        config: { ...state.config, page: action.payload },
      };
    }
    case QR_DIAGNOSTICS.SET_ITEM:
      return { ...state, item: action.payload };
    case QR_DIAGNOSTICS.CHANGE_SORT_FIELD: {
      return {
        ...action.payload,
      };
    }
    case QR_DIAGNOSTICS.UPDATE_CONFIG: {
      return {
        ...state,
        config: { ...state.config, ...action.payload },
      };
    }
    case QR_DIAGNOSTICS.RESET_TO_DEFAULT:
      return INIT_STATE;
    default:
      return state;
  }
};
